import {getNextDay} from "./util";


//expects only the array "days" within the item
export function itemAvailableTomorrow(item){
    if(!item || !item.days){
        return false;
    }
    let nextDay = getNextDay();
    return item.days.includes(''+nextDay);
}